import { SITE_NAME } from "../const/const";

export const getPageTitle = (page?: string) => page ? `${SITE_NAME} - ${page}` : SITE_NAME;